module.exports = __webpack_public_path__ + "img/20210419203636686alk.4cc019e2.png";